import React from "react";

const FeedbackIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 88 84"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={"currentColor"}
      d="M44 0L60.7636 22.9268L87.7486 31.7852L71.1241 54.8132L71.0381 83.2148L44 74.52L16.9619 83.2148L16.8759 54.8132L0.2514 31.7852L27.2364 22.9268L44 0Z"
    ></path>
  </svg>
);

export default FeedbackIcon;
